import React, { Component } from 'react';
import AccessContainer from '../../access/AccessContainer';
import { RootState } from '../../../redux/store';
import { changeBasic } from '../../../redux/actions/BasicActions';
import { ConnectedProps } from 'react-redux/es/exports';
import { connect } from 'react-redux';
import { AccessBase } from '../../../domain/access/BaseAccess';
import { changeListVariable } from 'redux/actions/ListVariableActions';
import RoleHelper from '../../../RoleHelper';

class EnrichmentListAccessComponent extends Component<Props> {
  render() {
    const {
      listVariable: { listVariable },
    } = this.props;
    const access: AccessBase = { permission: listVariable.permission, collaborators: listVariable.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeBasicVariableAccess} disabled={!RoleHelper.canManage('EnrichmentList')} />;
  }

  private changeBasicVariableAccess = (access: AccessBase) => {
    const {
      listVariable: { listVariable },
      changeListVariable,
    } = this.props;
    listVariable.permission = access.permission;
    listVariable.collaborators = access.collaborators;
    changeListVariable(listVariable);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  listVariable: state.listVariable,
});
const mapDispatchToProps = { changeListVariable };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(EnrichmentListAccessComponent);
